/**
 * Template: SCA Store Locator
 * -----------------------------------------------------------------------------
 * Used to initalise datalayer scripts on the SCA Store Locator page template.
 *
 */
import StoreLocatorDatalayer from '~/components/storelocator-datalayer'
document.addEventListener('DOMContentLoaded', () => {

  StoreLocatorDatalayer().init()
})
